import colors from '@colors'
import {Stack, styled, Typography} from '@mui/material'

export const DropzoneWrapper = styled(Stack)(({theme}) => ({
  height: '200px',
  border: `1px dashed ${theme.palette.grey[100]}`,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '1rem',
  cursor: 'pointer',
}))

export const iconStyle = {
  fontSize: '3rem',
}

export const disabledTextStyle = {
  color: colors.gray['2'],
}

export const disabledIconStyle = {
  fontSize: '3rem',
  color: colors.gray['2'],
}

export const errorIconStyle = {
  fontSize: '2rem',
  color: colors.error.main,
}

export const previewStyle = {
  width: '100%',
  height: '420px',
  borderRadius: 8,
  borderWidth: 1,
  BorderColor: colors.gray['2'],
}

export const KeyValueRowWrapper = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  gap: 5,
  height: 25,
  alignItems: 'center',
  borderBottomWidth: 1,
  borderBottomStyle: 'dashed',
  borderBottomColor: theme.palette.grey[200],
}))

export const KeyValueText = styled(Typography)(() => ({
  flex: 2,
  fontSize: '0.75rem',
  textAlign: 'start',
}))

export const KeyValueKey = styled(Typography)(() => ({
  flex: 3,
  fontSize: '0.75rem',
  textAlign: 'start',
  fontWeight: 'bold',
}))
